export const sideBarRightVisibilityChanged = (payload) => ({
  type: sideBarRightVisibilityChanged.toString(),
  payload
})
sideBarRightVisibilityChanged.toString = () =>
  'sideBarRight/sideBarRightVisibilityChanged'

export const setDataTable = (payload) => ({
  type: setDataTable.toString(),
  payload
})
setDataTable.toString = () => 'sideBarRight/setDataTable'

export const setFeaturesDataTable = (payload) => ({
  type: setFeaturesDataTable.toString(),
  payload
})
setFeaturesDataTable.toString = () => 'sideBarRight/setFeaturesDataTable'

export const loadingIssues = (payload) => ({
  type: loadingIssues.toString(),
  payload
})
loadingIssues.toString = () => 'sideBarRight/loadingIssues'

const sideBarRightReducer = {
  [sideBarRightVisibilityChanged]: (draftState, { isOpen, selectedType }) => {
    draftState.sideBarRight.isOpen =
      isOpen !== undefined ? isOpen : draftState.sideBarRight.isOpen
    draftState.sideBarRight.selectedType = selectedType
      ? selectedType
      : draftState.sideBarRight.selectedType
  },
  [setDataTable]: (draftState, { dataTable }) => {
    draftState.sideBarRight.dataTable = dataTable
  },
  [setFeaturesDataTable]: (draftState, { dataTable }) => {
    draftState.sideBarRight.featuresDataTable = dataTable
  },
  [loadingIssues]: (draftState, { isLoading }) => {
    draftState.sideBarRight.loadingIssues = isLoading
  }
}

export default sideBarRightReducer
